export default function openPopup(url, width = 626, height = 436) {
  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;

  const popup = window.open(url, '_blank', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`);

  if (popup) {
    if (popup.moveTo) {
      popup.moveTo(left, top);
    }
    popup.focus();
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/utils/open-popup.js